/**
 * YouTube IFrame Player API のロード（要件定義 3.3）。
 *
 * スクリプトはページに 1 度だけ読み込む。
 * 読み込みは Player を実際に使う直前まで遅延させ、初期表示を軽くする。
 */

const SCRIPT_SRC = 'https://www.youtube.com/iframe_api'

let apiPromise: Promise<typeof YT> | null = null

export const loadYouTubeApi = (): Promise<typeof YT> => {
  if (apiPromise) return apiPromise

  apiPromise = new Promise<typeof YT>((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('ブラウザ以外では YouTube Player を読み込めません'))
      return
    }
    if (window.YT?.Player) {
      resolve(window.YT)
      return
    }

    // API 側は window.onYouTubeIframeAPIReady を呼ぶ。他の呼び出しも壊さないよう繋ぐ
    const previous = window.onYouTubeIframeAPIReady
    window.onYouTubeIframeAPIReady = () => {
      previous?.()
      resolve(window.YT)
    }

    const existing = document.querySelector<HTMLScriptElement>(`script[src="${SCRIPT_SRC}"]`)
    if (existing) return

    const script = document.createElement('script')
    script.src = SCRIPT_SRC
    script.async = true
    script.onerror = () => {
      apiPromise = null
      reject(new Error('YouTube IFrame Player API を読み込めませんでした'))
    }
    document.head.appendChild(script)
  })

  return apiPromise
}

/** YouTube 側のエラーコードを人が読める理由に変換する（要件定義 13 章） */
export const playerErrorReason = (code: number): string => {
  switch (code) {
    case 2:
      return '動画 ID が不正です'
    case 5:
      return 'この環境では再生できません'
    case 100:
      return '動画が削除されたか非公開です'
    case 101:
    case 150:
      return '埋め込みが許可されていません'
    default:
      return `再生エラー (${code})`
  }
}
